export const getCleanListValues = (value: string | string[]) => {
  const values = Array.isArray(value) ? value : [value];
  return values.filter(Boolean);
};
